import { render, staticRenderFns } from "./ProgramsSingleUploadDocuments.vue?vue&type=template&id=27b4789d&scoped=true&"
import script from "./ProgramsSingleUploadDocuments.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleUploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsSingleUploadDocuments.vue?vue&type=style&index=0&id=27b4789d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4789d",
  null
  
)

export default component.exports